import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const paymentRunStatusFeatureKey = 'paymentRunStatus';

export interface PaymentRunStatusState {
  loadPaymentRunStatus: any;
  loadPaymentRunStatusResponse: any;
  isLoaded: boolean;
}

export const initialState: PaymentRunStatusState = {
  loadPaymentRunStatus: undefined,
  loadPaymentRunStatusResponse: undefined,
  isLoaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPaymentRunStatus, (state, action) => ({
    ...state,
    loadPaymentRunStatus: action.request
  })),
  on(actions.loadPaymentRunStatusSuccess, (state, action) => ({
    ...state,
    loadPaymentRunStatusResponse: action.response,
    isLoaded: true
  }))
);

export const getPaymentRunStatus = (state: PaymentRunStatusState) => state.loadPaymentRunStatusResponse;

export const getPaymentRunStatusIsLoaded = (state: PaymentRunStatusState) => state.isLoaded;
